/**
 * Adds a button to a given .RB_PC_Media element if it doesn't already have one.
 * @param {Element} mediaElement The .RB_PC_Media element.
 */
function getSectionsToRender() {
  return [
    {
      id: 'Cart',
      section: 'main-cart',
      selector: '.thb-cart-form'
    },
    {
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '.cart-drawer'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }
  ];
}

function getSectionInnerHTML(html, selector = '.shopify-section') {
  return new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector(selector).innerHTML;
}

function renderCartContents(parsedState) {
  getSectionsToRender().forEach((section) => {
    if (!document.getElementById(section.id)) {
      return;
    }

    const elementToReplace =
      document.getElementById(section.id).querySelector(section.selector) ||
      document.getElementById(section.id);

    elementToReplace.innerHTML = getSectionInnerHTML(
      parsedState.sections[section.section],
      section.selector
    );

    if (typeof Cart !== 'undefined') {
      new Cart().renderContents(parsedState);
    }

    if (section.id === 'Cart-Drawer') {
      document.getElementById('Cart-Drawer')?.removeProductEvent();
    }
  });

  if (document.getElementById('Cart-Drawer')) {
    document.getElementById('Cart-Drawer').open();
  }
}

async function addUpsellItemToCart(variantId) {
  if (!variantId) {
    return { success: false };
  }

  const config = {
    method: 'POST',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/javascript'
    }
  };

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', 1);
  formData.append('sections', getSectionsToRender().map((section) => section.section));
  formData.append('sections_url', window.location.pathname);
  config.body = formData;

  const cartAddUrl = window.theme?.routes?.cart_add_url || '/cart/add.js';
  const response = await fetch(`${cartAddUrl}`, config);
  const parsedResponse = await response.json();

  if (parsedResponse.status) {
    if (parsedResponse.status === 422) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
    }
    return { success: false, response: parsedResponse };
  }

  renderCartContents(parsedResponse);

  if (typeof dispatchCustomEvent === 'function') {
    dispatchCustomEvent('cart:item-added', {
      product: parsedResponse.hasOwnProperty('items') ? parsedResponse.items[0] : parsedResponse
    });
  } else {
    document.documentElement.dispatchEvent(new CustomEvent('cart:item-added', {
      bubbles: true,
      detail: {
        product: parsedResponse.hasOwnProperty('items') ? parsedResponse.items[0] : parsedResponse
      }
    }));
  }

  return { success: true, response: parsedResponse };
}

function addMediaButton(mediaElement) {
  if (mediaElement.querySelector('.RB_PC_Add_Button')) {
    // Button already exists, do nothing.
    return;
  }

  const lang = document.documentElement.lang.split('-')[0] || "en";

  const translations = {
    en: { add: 'Add', remove: 'Remove' },
    fr: { add: 'Ajouter', remove: 'Supprimer' },
    sv: { add: 'Lägg till', remove: 'Ta bort' },
    es: { add: 'Añadir', remove: 'Eliminar' },
    pt: { add: 'Adicionar', remove: 'Remover' },
    fi: { add: 'Lisää', remove: 'Poista' },
    no: { add: 'Legg til', remove: 'Fjern' },
    it: { add: 'Aggiungi', remove: 'Rimuovi' }
  };
  const buttonTexts = translations[lang] || translations.en;
  const loadingSvg = `
    <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle class="spinner-path" fill="none" stroke-width="6" cx="33" cy="33" r="30" stroke="var(--color-body)"></circle>
    </svg>
  `;

  function renderIdleButtonState() {
    button.classList.remove('loading');
    button.removeAttribute('aria-disabled');
    button.innerHTML = `<span>${buttonTexts.add}</span><span class="loading-overlay">${loadingSvg}</span>`;
    button.classList.add('accent');
  }

  function renderLoadingButtonState() {
    button.classList.add('loading');
    button.setAttribute('aria-disabled', 'true');
    button.innerHTML = `<span>${buttonTexts.add}</span><span class="loading-overlay">${loadingSvg}</span>`;
  }

  function getSelectedVariantId() {
    const selector = mediaElement.querySelector('.RB_PC_Selector');
    if (selector) {
      // If selector exists, only use its value (don't fall back to dataset)
      return selector.value && selector.value.trim() ? selector.value : '';
    }
    // Only use dataset if there's no selector element
    const dataValue = mediaElement.dataset.vid || mediaElement.dataset.id || mediaElement.dataset.pid || '';
    return dataValue && dataValue.trim() ? dataValue : '';
  }

  function syncButtonDisabledState() {
    const selectedVariantId = getSelectedVariantId();
    const hasSelection = !!selectedVariantId;

    button.disabled = !hasSelection;
    button.setAttribute('aria-disabled', hasSelection ? 'false' : 'true');

    if (hasSelection) {
      button.classList.add('accent');
    } else {
      button.classList.remove('loading');
      button.classList.remove('accent');
      button.innerHTML = `<span>${buttonTexts.add}</span><span class="loading-overlay">${loadingSvg}</span>`;
    }
  }

  const button = document.createElement('button');
  button.classList.add('RB_PC_Add_Button');
  button.classList.add('button');
  button.type = 'button';
  button.innerHTML = `<span>${buttonTexts.add}</span><span class="loading-overlay">${loadingSvg}</span>`;

  mediaElement.appendChild(button);
  syncButtonDisabledState();

  const selector = mediaElement.querySelector('.RB_PC_Selector');
  if (selector) {
    selector.addEventListener('change', syncButtonDisabledState);
  }

  button?.addEventListener('click', async (event) => {
    event.preventDefault();

    if (button.disabled || button.classList.contains('loading') || button.getAttribute('aria-disabled') === 'true') {
      return;
    }

    const variantId = getSelectedVariantId();
    if (!variantId) {
      syncButtonDisabledState();
      renderIdleButtonState();
      return;
    }

    renderLoadingButtonState();

    try {
      await addUpsellItemToCart(variantId);
    } catch (error) {
      console.error(error);
    } finally {
      renderIdleButtonState();
    }
  });

  setTimeout(syncButtonDisabledState, 300)
}

/**
 * Handles mutations to find and process newly added .RB_PC_Media elements.
 * @param {MutationRecord[]} mutationsList The list of mutations.
 */
function handleMutations(mutationsList) {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          // Check if the added node is a .wcpb_ao_section or contains them
          if (node.matches('.wcpb_ao_section')) {
            node.querySelectorAll('.RB_Product_Card').forEach(addMediaButton);
          }

          // Check if the added node is a .RB_PC_Media inside a .wcpb_ao_section
          if (node.matches('.RB_Product_Card') && node.closest('.wcpb_ao_section')) {
            addMediaButton(node);
          }

          // Check for .RB_PC_Media elements within any added node
          node.querySelectorAll('.RB_Product_Card').forEach(mediaElement => {
            if (mediaElement.closest('.wcpb_ao_section')) {
              addMediaButton(mediaElement);
            }
          });
        }
      });
    }
  }
}

// Create a MutationObserver to watch for dynamically added elements.
const observer = new MutationObserver(handleMutations);

// Start observing the entire document body for changes.
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Also, process any elements that are already on the page when the script loads.
document.querySelectorAll('.wcpb_ao_section .RB_Product_Card').forEach(addMediaButton);

function moveKlaviyoSectionIntoProductGrid() {
  const appSection = Array.from(document.querySelectorAll('.shopify-section.section-app-wrapper')).find(
    (section) => section.querySelector('.shopify-block.shopify-app-block').id.includes("klaviyo")
  );
  const productGrid = document.querySelector('ul#product-grid');

  if (!appSection || !productGrid) {
    return;
  }

  const columnsMatch = productGrid.className.match(/medium-up-(\d+)/);
  const columns = columnsMatch ? parseInt(columnsMatch[1], 10) : 1;
  const productItems = Array.from(productGrid.children).filter(
    (child) => !child.classList.contains('loading-overlay')
  );
  const targetIndex = Math.min(productItems.length, columns * 3);
  const referenceNode = productGrid.children[targetIndex] || null;

  if (appSection.parentElement === productGrid && appSection.nextSibling === referenceNode) {
    return;
  }

  productGrid.insertBefore(appSection, referenceNode);
}

if (document.readyState === 'complete') {
  moveKlaviyoSectionIntoProductGrid();
} else {
  window.addEventListener('DOMContentLoaded', moveKlaviyoSectionIntoProductGrid, { once: true });
}

// Apply visual preview discount to Rebolt add-on prices when cart contains a phone case
async function applyAddonDiscountsToRebolt() {
  try {
    const addonPercent = Number(window.theme?.settings?.add_ons_discount_percent || 0);
    if (!addonPercent || addonPercent <= 0) return;

    const cartResp = await fetch('/cart.js');
    if (!cartResp.ok) return;
    const cart = await cartResp.json();
    // Only apply discount when cart has 2 or more items
    if (!cart.items || cart.items.length % 2 == 0) return;

    document.querySelectorAll('.RB_PC_Price').forEach(priceEl => {
      try {
        // Only operate on add-on cards that look like a case (title contains 'case')
        const card = priceEl.closest('.RB_Product_Card');
        const titleEl = card && (card.querySelector('.RB_PC_Title') || card.querySelector('.RB_PC_Title a'));
        const titleText = titleEl ? (titleEl.textContent || '').toString().toLowerCase() : '';
        if (!titleText.includes('case')) return;

        const saleEl = priceEl.querySelector('.RB_PC_Sale_Price');
        if (!saleEl) return;
        const originalText = saleEl.textContent || '';
        // Extract numeric portion
        const raw = originalText.replace(/[^0-9.,]/g, '');
        if (!raw) return;
        let numeric = raw;
        if (numeric.indexOf(',') > -1 && numeric.indexOf('.') === -1) {
          numeric = numeric.replace(',', '.');
        } else {
          numeric = numeric.replace(/,/g, '');
        }
        const value = parseFloat(numeric);
        if (isNaN(value)) return;
        const discounted = (value * (100 - addonPercent)) / 100;

        // Decide decimals based on original format
        const useDecimals = raw.indexOf('.') !== -1 || raw.indexOf(',') !== -1 && raw.indexOf('.') !== -1;
        let newNumeric = useDecimals ? discounted.toFixed(2) : Math.round(discounted).toString();

        // Replace first numeric substring in originalText with newNumeric
        const replaced = originalText.replace(/([0-9]+[.,]?[0-9]*)/, newNumeric);

        // Show compare-at (original) and new sale price
        const origDisplay = saleEl.textContent.trim();
        saleEl.innerHTML = `<del class="rb-addon-orig">${origDisplay}</del> <ins class="rb-addon-new">${replaced}</ins>`;
      } catch (e) {
        // ignore per-item errors
      }
    });
  } catch (e) {
    // Non-fatal
  }
}

// Run once on load
applyAddonDiscountsToRebolt();








// --------------------------------------------------
// Set properties[_source] => "p_1058" when elnacional cookie is set
// --------------------------------------------------

const elNacionalId = "p_1058"
function setSourceValueToElnacional(root = document) {
  const selector = 'fieldset.product-form__input.product-information--line-item input[name="properties[_source]"]';
  root.querySelectorAll(selector).forEach(input => {
    try {
      if (input && input.value !== elNacionalId) {
        input.value = elNacionalId;
        // Notify any listeners (some libraries listen for input/change)
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } catch (e) {
      // Defensive: ignore any readonly or other assignment errors
      // (shouldn't usually happen for hidden inputs)
    }
  });
}

// Helper: check for elnacional cookie (accepts both ':' and '=' styles)
function hasElnacionalCookie() {
  try {
    const c = document.cookie || '';
    return c.includes('elnacional=true');
  } catch (e) {
    return false;
  }
}

// Observe for dynamically added fieldsets/inputs and update them
const sourceObserver = new MutationObserver(mutations => {
  for (const m of mutations) {
    if (m.type === 'childList') {
      m.addedNodes.forEach(node => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;

        // If the added node itself contains matching inputs, update them
        setSourceValueToElnacional(node);

        // If the added node is the fieldset itself, update directly
        if (node.matches && node.matches('fieldset.product-form__input.product-information--line-item')) {
          setSourceValueToElnacional(node);
        }
      });
    }
  }
});

sourceObserver.observe(document.body, { childList: true, subtree: true });

// Only run the initial updater and start observing when the elnacional cookie is present
if (hasElnacionalCookie()) {
  // Run once for existing inputs
  setSourceValueToElnacional();

  // Start observing for dynamically added inputs
  sourceObserver.observe(document.body, { childList: true, subtree: true });
}

/* Enhance horizontal .RB_Product_View with custom scrollbar and floating arrows */
function createScrollArrowsFor(container) {
  if (!container || container.dataset.rbEnhanced === '1') return;

  container.dataset.rbEnhanced = '1';
  container.style.position = container.style.position || '';

  // Create custom scrollbar track and thumb (works on all platforms including Mac)
  const scrollbarTrack = document.createElement('div');
  scrollbarTrack.className = 'rb-scrollbar-track';
  scrollbarTrack.style.cssText = `
    position: absolute;
    bottom: 2px;
    left: 0;
    right: 0;
    height: 8px;
    background: rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    z-index: 20;
  `;

  const scrollbarThumb = document.createElement('div');
  scrollbarThumb.className = 'rb-scrollbar-thumb';
  scrollbarThumb.style.cssText = `
    position: absolute;
    height: 8px;
    background: linear-gradient(90deg, rgba(0, 0, 0, 0.28), rgba(0, 0, 0, 0.22));
    border-radius: 4px;
    cursor: grab;
    transition: background 160ms ease;
  `;
  scrollbarTrack.appendChild(scrollbarThumb);

  const wrapper = document.createElement('div');
  wrapper.style.cssText = `
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 14px;
    pointer-events: none;
    z-index: 20;
  `;
  wrapper.appendChild(scrollbarTrack);
  container.style.position = 'relative';
  container.insertAdjacentElement('afterend', wrapper);

  // Arrow buttons
  const leftBtn = document.createElement('button');
  leftBtn.className = 'rb-scroll-arrow left hidden';
  leftBtn.setAttribute('aria-hidden', 'true');
  leftBtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path></svg>';

  const rightBtn = document.createElement('button');
  rightBtn.className = 'rb-scroll-arrow right hidden';
  rightBtn.setAttribute('aria-hidden', 'true');
  rightBtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z"></path></svg>';

  container.insertAdjacentElement('afterend', leftBtn);
  container.insertAdjacentElement('afterend', rightBtn);

  function updateScrollbar() {
    const scrollWidth = container.scrollWidth;
    const clientWidth = container.clientWidth;
    const scrollLeft = container.scrollLeft;

    if (scrollWidth <= clientWidth + 1) {
      scrollbarTrack.style.opacity = '0';
      leftBtn.classList.add('hidden');
      rightBtn.classList.add('hidden');
      return;
    }

    scrollbarTrack.style.opacity = '1';
    const ratio = clientWidth / scrollWidth;
    const thumbWidth = Math.max(clientWidth * ratio, 40);
    const thumbLeft = (scrollLeft / scrollWidth) * clientWidth;

    scrollbarThumb.style.width = thumbWidth + 'px';
    scrollbarThumb.style.left = thumbLeft + 'px';

    // Update arrow visibility
    if (scrollLeft <= 8) {
      leftBtn.classList.add('hidden');
    } else {
      leftBtn.classList.remove('hidden');
    }

    if (scrollLeft >= scrollWidth - clientWidth - 8) {
      rightBtn.classList.add('hidden');
    } else {
      rightBtn.classList.remove('hidden');
    }
  }

  let isDragging = false;
  let dragStartX = 0;
  let dragStartScroll = 0;

  scrollbarThumb.addEventListener('mousedown', (e) => {
    isDragging = true;
    dragStartX = e.clientX;
    dragStartScroll = container.scrollLeft;
    scrollbarThumb.style.cursor = 'grabbing';
    e.preventDefault();
  });

  document.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    const delta = e.clientX - dragStartX;
    const ratio = container.scrollWidth / container.clientWidth;
    container.scrollLeft = dragStartScroll + delta * ratio;
  });

  document.addEventListener('mouseup', () => {
    isDragging = false;
    scrollbarThumb.style.cursor = 'grab';
  });

  let scrollTimeout;
  container.addEventListener('scroll', () => {
    updateScrollbar();
    scrollbarTrack.style.opacity = '1';
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      updateScrollbar();
    }, 250);
  }, { passive: true });

  leftBtn.addEventListener('click', () => {
    container.scrollBy({ left: -Math.round(container.clientWidth * 0.8), behavior: 'smooth' });
  });

  rightBtn.addEventListener('click', () => {
    container.scrollBy({ left: Math.round(container.clientWidth * 0.8), behavior: 'smooth' });
  });

  // Observe size changes to update scrollbar
  try {
    const ro = new ResizeObserver(updateScrollbar);
    ro.observe(container);
  } catch (e) {
    window.addEventListener('resize', updateScrollbar);
  }

  // Initial update
  setTimeout(updateScrollbar, 50);
}

function enhanceRBProductViews() {
  document.querySelectorAll('.RB_Addon_Wrapper .RB_Product .RB_Product_View').forEach(createScrollArrowsFor);
}

// Run once now
enhanceRBProductViews();

// Watch for dynamically added RB_Product_View containers and enhance them
const rbViewObserver = new MutationObserver((mutations) => {
  for (const m of mutations) {
    if (m.type === 'childList') {
      m.addedNodes.forEach(node => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        if (node.matches && node.matches('.RB_Product_View')) {
          createScrollArrowsFor(node);
        }
        node.querySelectorAll && node.querySelectorAll('.RB_Product .RB_Product_View').forEach(createScrollArrowsFor);
      });
    }
  }
});

rbViewObserver.observe(document.body, { childList: true, subtree: true });


/*
Rebolt bundle addon structure
<div id="shopify-block-AUFcxeU5iQkY4bkhhb__rebolt_bundles_addon_product_KWfmfQ" class="shopify-block shopify-app-block"><div class="wcpb_ao_section" data-wcpid="12070784074068"><style>
    .RB_Addon_Wrapper .RB_Section_Tilte h4{font-size:13px; color: #121212}
    .RB_Addon_Wrapper[data-bundleid="170219"] .RB_Product_Card .RB_PC_Media{border: 1px solid #e5e5e5}
    .RB_Addon_Wrapper .RB_Product_Card .RB_PC_Title a{font-size: 13px; color: #121212}
    .RB_Addon_Wrapper .RB_Product_Card .RB_PC_Price{font-size: 14px}
    .RB_Addon_Wrapper .RB_Product_Card .RB_PC_Price span{color: #121212}
    .RB_Addon_Wrapper span.RB_LoadingSpinner{border-left-color: #FFFFFF; border-right-color: #FFFFFF}
    .RB_Addon_Wrapper .RB_Button{background-color: #008060; color: #FFFFFF; font-size: 14px}
    .RB_Addon_Wrapper .RB_PC_Variants_Legend{font-size: 11px; color: #121212}
    .RB_Addon_Wrapper .RB_ModalClose{background-color: #008060;color: #FFFFFF}
  </style><div class="RB_Addon_Wrapper" data-bundleid="170219"><div class="RB_Section_Tilte"><h4>Complete your collection and save 15%</h4></div><div class="RB_Product RB_Product_Layout_3"><div class="RB_Product_View RB_PV_Index_1" data-rb-enhanced="1" style="position: relative;"><div class="RB_Product_List "><div class="RB_Product_Card" data-id="12086206366036" data-pid="12086206366036" data-vid="52080213852500" data-status="false"><div class="RB_PC_Media"><img src="//cdn.shopify.com/s/files/1/0918/7229/7300/files/screenprotector-image-1.webp?v=1750086029" alt="Screen Protector"><input type="checkbox" class="RB_PC_Media_Checkbox" style="accent-color: rgb(0, 0, 0);"></div><div class="RB_PC_Content"><div class="RB_PC_Title"><a href="/products/screen-protector" target="_blank">Screen Protector</a></div><div class="RB_PC_Price"><span class="RB_PC_CompareAt_Price">99 kr</span><span class="RB_PC_Sale_Price">84 kr</span></div><div class="RB_PC_VariantBox"><fieldset class="RB_PC_Variants"><select class="RB_PC_Selector" data-rb-listener-attached="true" data-prev-value="52080213852500"><option value="" class="placeholder" disabled="">Select your phone model</option><option disabled="" value="">Please select </option><option value="52080212934996">Samsung Galaxy Note 20 ULTRA</option><option value="52080212967764">Samsung Galaxy S20</option><option value="52080213000532">Samsung Galaxy S20 Pro</option><option value="52080213033300">Samsung Galaxy S20 Ultra</option><option value="52080213066068">Samsung Galaxy S21</option><option value="52080213098836">Samsung Galaxy S21 FE</option><option value="52080213131604">Samsung Galaxy S21 Pro</option><option value="52080213164372">Samsung Galaxy S21 Ultra</option><option value="52080213197140">Samsung Galaxy S22</option><option value="52080213229908">Samsung Galaxy S22 Pro</option><option value="52080213262676">Samsung Galaxy S22 Ultra</option><option value="52080213295444">Samsung Galaxy S23</option><option value="52080213328212">Samsung Galaxy S23 pro</option><option value="52080213360980">Samsung Galaxy S23 Ultra</option><option value="52080213393748">Samsung Galaxy S24</option><option value="52080213426516">Samsung Galaxy S24 Plus/Pro</option><option value="52080213459284">Samsung Galaxy S24 Ultra</option><option value="52080213492052">Samsung Galaxy S9 Plus</option><option value="52080213524820">Samsung Galaxy A32</option><option value="52080213557588">Samsung Galaxy A50</option><option value="52080213590356">Samsung Galaxy A52/A52s 5G</option><option value="52080213623124">Samsung Galaxy A53</option><option value="52080213655892">iPhone 11</option><option value="52080213688660">iPhone 11 Pro</option><option value="52080213721428">iPhone 11 Pro Max</option><option value="52080213754196">iPhone 12</option><option value="52080213786964">iPhone 12 mini</option><option value="52080213819732">iPhone 12 Pro</option><option value="52080213852500">iPhone 12 Pro Max</option><option value="52080213885268">iPhone 13</option><option value="52080213918036">iPhone 13 mini</option><option value="52080213950804">iPhone 13 Pro</option><option value="52080213983572">iPhone 13 Pro Max</option><option value="52080214016340">iPhone 14</option><option value="52080214049108">iPhone 14 Plus</option><option value="52080214081876">iPhone 14 Pro</option><option value="52080214114644">iPhone 14 Pro Max</option><option value="52080214147412">iPhone 15</option><option value="52080214180180">iPhone 15 Plus</option><option value="52080214212948">iPhone 15 Pro</option><option value="52080214245716">iPhone 15 Pro Max</option><option value="52080214278484">iPhone 16</option><option value="52080214311252">iPhone 16 Plus</option><option value="52080214344020">iPhone 16 Pro</option><option value="52080214376788">iPhone 16 Pro Max</option><option value="52080214409556">iPhone 7</option><option value="52080214442324">iPhone 7 Plus</option><option value="52080214475092">iPhone 8</option><option value="52080214507860">iPhone 8 Plus</option><option value="52080214540628">iPhone X</option></select></fieldset></div></div><button class="RB_PC_Add_Button button accent" type="button" aria-disabled="false"><span>Add</span><span class="loading-overlay">
    <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle class="spinner-path" fill="none" stroke-width="6" cx="33" cy="33" r="30" stroke="var(--color-body)"></circle>
    </svg>
  </span></button></div></div><div class="RB_Product_List "><div class="RB_Product_Card" data-id="12106399351124" data-pid="12106399351124" data-vid="52150128574804" data-status="false"><div class="RB_PC_Media"><img src="https://cdn.shopify.com/s/files/1/0918/7229/7300/files/C_FCB44-IP12PROMAX.webp?v=1777108162" alt="FC Barcelona Official Compostable Phone Case Full Color crest and stripes + Name"><input type="checkbox" class="RB_PC_Media_Checkbox" style="accent-color: rgb(0, 0, 0);"></div><div class="RB_PC_Content"><div class="RB_PC_Title"><a href="/products/fc-barcelona-official-compostable-phone-case-design-44" target="_blank">FC Barcelona Official Compostable Phone Case Full Color crest and stripes + Name</a></div><div class="RB_PC_Price"><span class="RB_PC_CompareAt_Price">348 kr</span><span class="RB_PC_Sale_Price">296 kr</span></div><div class="RB_PC_VariantBox"><fieldset class="RB_PC_Variants"><select class="RB_PC_Selector" data-rb-listener-attached="true" data-prev-value="52150128574804"><option value="" class="placeholder" disabled="">Select your phone model</option><option disabled="" value="">Please select </option><option value="52150128410964">iPhone 11</option><option value="52150128443732">iPhone 11 Pro</option><option value="52150128476500">iPhone 11 Pro Max</option><option value="52150128509268">iPhone 12</option><option value="52150128542036">iPhone 12 Pro</option><option value="52150128574804">iPhone 12 Pro Max</option><option value="52150128607572">iPhone 13</option><option value="52150128640340">iPhone 13 Pro</option><option value="52150128673108">iPhone 13 Pro Max</option><option value="52150128705876">iPhone 14</option><option value="52150128738644">iPhone 14 Plus</option><option value="52150128771412">iPhone 14 Pro</option><option value="52150128804180">iPhone 14 Pro Max</option><option value="52150128836948">iPhone 15</option><option value="52150128869716">iPhone 15 Plus</option><option value="52150128902484">iPhone 15 Pro</option><option value="52150128935252">iPhone 15 Pro Max</option><option value="52150128968020">iPhone 16</option><option value="52150129000788">iPhone 16 Plus</option><option value="52150129033556">iPhone 16 Pro</option><option value="52150129066324">iPhone 16 Pro Max</option><option value="52150129099092">iPhone 6</option><option value="52150129131860">iPhone 7</option><option value="52150129164628">iPhone 8</option><option value="52150129197396">Samsung Galaxy S20</option><option value="52150129230164">Samsung Galaxy S20 FE</option><option value="52150129262932">Samsung Galaxy S20 Pro</option><option value="52150129295700">Samsung Galaxy S20 Ultra</option><option value="52150129328468">Samsung Galaxy S21</option><option value="52150129361236">Samsung Galaxy S21 Pro</option><option value="52150129394004">Samsung Galaxy S21 Ultra</option><option value="52150129426772">Samsung Galaxy S22</option><option value="52150129459540">Samsung Galaxy S22 Pro</option><option value="52150129492308">Samsung Galaxy S22 Ultra</option><option value="52150129525076">Samsung Galaxy S23</option><option value="52150129557844">Samsung Galaxy S23 pro</option><option value="52150129590612">Samsung Galaxy S23 Ultra</option><option value="52150129623380">Samsung Galaxy S24</option><option value="52150129656148">Samsung Galaxy S24 Plus/Pro</option><option value="52150129688916">Samsung Galaxy S24 Ultra</option><option value="52572170223956">iPhone 16e</option><option value="52572170256724">Samsung Galaxy S25</option><option value="52572170289492">Samsung Galaxy S25 Plus</option><option value="52572170322260">Samsung Galaxy S25 Ultra</option><option value="53065061728596">iPhone 17</option><option value="53065061761364">iPhone 17 Air</option><option value="53065061794132">iPhone 17 Pro</option><option value="53065061826900">iPhone 17 Pro Max</option><option value="55619405578580">Samsung Galaxy A55</option><option value="55673781846356">iPhone 17e</option></select></fieldset></div></div><button class="RB_PC_Add_Button button accent" type="button" aria-disabled="false"><span>Add</span><span class="loading-overlay">
    <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle class="spinner-path" fill="none" stroke-width="6" cx="33" cy="33" r="30" stroke="var(--color-body)"></circle>
    </svg>
  </span></button></div></div><div class="RB_Product_List "><div class="RB_Product_Card" data-id="12267203297620" data-pid="12267203297620" data-vid="52644983734612" data-status="false"><div class="RB_PC_Media"><img src="//cdn.shopify.com/s/files/1/0918/7229/7300/files/FCB28-ALL-1.webp?v=1759307490" alt="Barcelona FC Official Compostable Phone Grip Design 28"><input type="checkbox" class="RB_PC_Media_Checkbox" style="accent-color: rgb(0, 0, 0);"></div><div class="RB_PC_Content"><div class="RB_PC_Title"><a href="/products/barcelona-fc-official-compostable-phone-grip-design-28" target="_blank">Barcelona FC Official Compostable Phone Grip Design 28</a></div><div class="RB_PC_Price"><span class="RB_PC_CompareAt_Price">119 kr</span><span class="RB_PC_Sale_Price">101 kr</span></div></div><button class="RB_PC_Add_Button button accent" type="button" aria-disabled="false"><span>Add</span><span class="loading-overlay">
    <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle class="spinner-path" fill="none" stroke-width="6" cx="33" cy="33" r="30" stroke="var(--color-body)"></circle>
    </svg>
  </span></button></div></div></div><button class="rb-scroll-arrow right" aria-hidden="true"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z"></path></svg></button><button class="rb-scroll-arrow left hidden" aria-hidden="true"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path></svg></button><div style="position: absolute; bottom: 0px; left: 0px; right: 0px; height: 14px; pointer-events: none; z-index: 20;"><div class="rb-scrollbar-track" style="position: absolute; bottom: 2px; left: 0px; right: 0px; height: 8px; background: rgba(0, 0, 0, 0.08); border-radius: 4px; z-index: 20; opacity: 1;"><div class="rb-scrollbar-thumb" style="position: absolute; height: 8px; background: linear-gradient(90deg, rgba(0, 0, 0, 0.28), rgba(0, 0, 0, 0.22)); border-radius: 4px; cursor: grab; transition: background 160ms; width: 226.449px; left: 0px;"></div></div></div></div></div></div>
</div>
*/

// Show .ai-featured-products... only when URL contains both
// "happybytes-phone-cases" and "163387933012". Listen for URL changes.
(function () {



  function shouldShow() {
    const href = location.href;
    if (!href.includes('happybytes-phone-cases')) return true;
    if (href.includes('163387933012')) return true;

    return false;
  }

  function toggleFeatured() {
    const el = document.querySelector('.shopify-section > [class*="ai-featured-product-"]');

    if (!el) return;
    el.style.display = shouldShow() ? '' : 'none';
  }

  // Initial check
  toggleFeatured();

  // Listen for history changes (pushState/replaceState) and popstate
  const _push = history.pushState;
  history.pushState = function () {
    _push.apply(this, arguments);
    setTimeout(toggleFeatured, 0);
  };
  const _replace = history.replaceState;
  history.replaceState = function () {
    _replace.apply(this, arguments);
    setTimeout(toggleFeatured, 0);
  };
  window.addEventListener('popstate', toggleFeatured);

  // Also observe DOM in case the element is added later
  const mo = new MutationObserver(() => toggleFeatured());
  mo.observe(document.documentElement || document.body, { childList: true, subtree: true });
})();

